import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  makeStyles,
} from "@material-ui/core";
import {
  CardActions,
  ListBase,
  Loading,
  useAuthenticated,
  useListContext,
  useTranslate,
} from "react-admin";
import { getLocalDate, getLocalTime } from "../../../utils";
import { useEffect, useState } from "react";

import Adjust from "../../../components/Adjust";
import CIReceiptDialog from "../../../components/CIReceiptDialog";
import Void from "../../../components/Void";

const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: "100%",
    flex: "1 0 auto",
    marginTop: theme.defaultMarginTop,
    display: "flex",
    position: "relative",
    top: 0,
    bottom: 0,
  },
  title: theme.title,
  breadcrumb: {
    alignSelf: "start",
  },
  leftPanel: {
    backgroundColor: theme.default.normal.backgroundColor,
    width: "100%",
    overflowY: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 0 auto",
  },
  rightPanel: {
    backgroundColor: "white",
    overflowY: "scroll",
  },
  dataGrid_rowEven: {
    backgroundColor: "gray", //Not work
  },
  dataGrid_rowOdd: {
    backgroundColor: "red", //Not work
  },

  proceedButtonContainer: {
    backgroundColor: theme.default.normal.backgroundColor,
    width: "100%",
    height: 99,
    display: "flex",
    justifyContent: "center",
  },
  proceedButton: {
    width: 322,
    height: 57,
    fontSize: 28,
    fontWeight: "bold",
    alignSelf: "center",
  },

  searchButton: {
    borderRadius: 12,
  },
  searchandFilterContainer: {
    display: "grid",
    gridTemplateColumns: "400px 150px auto",
    columnGap: 8,
    alignItems: "center",
  },
}));

const TransactionsView = (props) => {
  useAuthenticated();
  const { id } = props;
  const classes = useStyles();
  //const translate = useTranslate();
  //const [viewState, setViewState] = useState(TRANSACTION_LIST);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  return (
    <Box className={classes.allContainer}>
      {
        <>
          <ListBase
            {...props}
            resource="transactions"
            basePath="/ci/member/profiles/:id"
            bulkActionButtons={false}
            perPage={100}
            actions={<NoneActions />}
            style={{ width: "100%" }}
            sort={{ field: "create_local_time", order: "DSC" }}
            filter={{
              member_id: id,
              from: "2000-01-01",
              to: "2700-12-31",
              bill_detail: { $ne: null },
            }}
          >
            <MyDatagrid
              selectRow={(transaction) => setSelectedTransaction(transaction)}
            ></MyDatagrid>
          </ListBase>
          <CIReceiptDialog
            transaction={selectedTransaction}
            open={selectedTransaction}
            onClose={() => setSelectedTransaction(null)}
            onClick={() => setSelectedTransaction(null)}
            showCommand
          />
        </>
      }
    </Box>
  );
};
const NoneActions = () => <CardActions />;

const useMyDataGridStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
  },
  tableContainer: {
    flexGrow: 1,
    flexBasis: 100,
    overflowY: "auto",
    position: "relative",
    bottom: 0,
  },
  loadingContainer: {
    flexGrow: 1,
    flexBasis: 100,
    overflowY: "none",
  },
  rowContainer: {
    backgroundColor: theme.white,
  },
  rowContainer_selected: {
    backgroundColor: theme.lightOrange,
  },
  rowHeight: {
    maxHeight: 68,
    paddingTop: 5,
    paddingBottom: 5,
    height: 68,
    boxSizing: "border-box",
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  fullname: { ...theme.h7 },
  time_text: { fontSize: 14 },
  point: {
    fontSize: 14,
    marginLeft: 4,
    color: theme.orange,
  },
  pointIcon: {
    width: 25,
    height: 25,
  },
  selectButton: {
    width: 89,
    height: 30,
  },
  titleTableText: {
    fontSize: 14,
  },
  tableHead: {
    height: 29,
    boxSizing: "border-box",
    padding: "0px 10px",
  },
  gray: {
    backgroundColor: theme.midGray,
  },
}));

const MyDatagrid = ({ selectRow }) => {
  const { data, ids, loading } = useListContext();

  const classes = useMyDataGridStyles();
  const translate = useTranslate();
  const { setFilters } = useListContext();
  useEffect(() => {
    setFilters({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (loading) return <Loading className={classes.loadingContainer} />;

  return (
    <Box className={classes.container}>
      <TableContainer className={classes.tableContainer}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableHead}>
                <Typography
                  className={classes.titleTableText}
                  noWrap
                ></Typography>
              </TableCell>
              <TableCell className={classes.tableHead}>
                <Typography className={classes.titleTableText}>
                  {translate("ra.text.ci.dateAndTime")}
                </Typography>
              </TableCell>

              <TableCell className={classes.tableHead}>
                <Typography className={classes.titleTableText} noWrap>
                  {translate("ra.text.ci.paymentMethod")}
                </Typography>
              </TableCell>
              <TableCell className={classes.tableHead}>
                <Typography className={classes.titleTableText} noWrap>
                  {translate("ra.text.ci.amount")}
                </Typography>
              </TableCell>
              <TableCell className={classes.tableHead}>
                <Typography className={classes.titleTableText}>
                  {translate("ra.text.ci.earnPoint")}
                </Typography>
              </TableCell>
              <TableCell className={classes.tableHead}>
                <Typography className={classes.titleTableText}>
                  {translate("ra.text.ci.pointAsCash")}
                </Typography>
              </TableCell>
              <TableCell className={classes.tableHead}>
                <Typography className={classes.titleTableText}>
                  {translate("ra.text.ci.adjust")}
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {ids.length > 0 ? (
              <>
                {ids.map((id, index) => {
                  const record = data[id];
                  //const id = record.id;
                  //if (record.type === "")
                  return (
                    <TableRow
                      key={id}
                      role="checkbox"
                      hover
                      onClick={() =>
                        record.payment_channels ? selectRow(record) : null
                      }
                      className={index % 2 === 0 ? classes.gray : null}
                    >
                      {/* first column: selection checkbox */}
                      <TableCell className={classes.rowHeight}>
                        <Box className={classes.flexRow}>
                          {record.status === "Void" ? (
                            <Void />
                          ) : record.last_adjust_amount?.reward ? (
                            <Adjust />
                          ) : null}
                        </Box>
                      </TableCell>
                      <TableCell
                        className={classes.rowHeight}
                        style={{ width: 100 }}
                      >
                        <Box className={classes.flexRow}>
                          <Box>
                            <Typography className={classes.time_text}>
                              {getLocalDate(record.create_local_time)}
                            </Typography>
                            <Typography className={classes.time_text}>
                              {getLocalTime(record.create_local_time)}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell className={classes.rowHeight}>
                        <Typography className={classes.fullname} noWrap>
                          {record.payment_channels
                            ? record.payment_channels
                                ?.map((pm) => pm.type)
                                .join(",")
                            : "Other"}
                        </Typography>
                      </TableCell>

                      <TableCell className={classes.rowHeight}>
                        <Box className={classes.flexRow}>
                          <Typography className={classes.point}>
                            {record.total_revenue
                              ? Number(
                                  record.total_revenue +
                                    (record.delivery_cost ?? 0)
                                )?.toLocaleString()
                              : "N/A"}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell className={classes.rowHeight}>
                        <Typography className={classes.point}>
                          {Object.values(record.earn).reduce(
                            (total, cur) => total + cur,
                            0
                          )}
                        </Typography>
                      </TableCell>
                      <TableCell className={classes.rowHeight}>
                        <Typography className={classes.point}>
                          {record.redeem?.reward}
                        </Typography>
                      </TableCell>
                      <TableCell className={classes.rowHeight}>
                        <Typography className={classes.point}>
                          {record.last_adjust_amount?.reward}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </>
            ) : null}
          </TableBody>
        </Table>
      </TableContainer>
      {ids.length <= 0 ? <NotFoundView /> : null}
    </Box>
  );
};

const NotFoundView = () => {
  return (
    <Typography align="center" variant="h5" style={{ marginTop: 20 }}>
      No transactions
    </Typography>
  );
};

export default TransactionsView;
